import GlobalData from "../GlobalData";
import { useAuthenticationStore } from "@/stores/authentication";
import AgencyListView from "@/views/AgencyList/AgencyListView.vue";
import AuditLogView from "@/views/AuditLog/AuditLogView.vue";
import ChartsDashboardView from "@/views/ChartsDashboard/ChartsDashboardView.vue";
import DownloadSecureView from "@/views/DownloadPackages/DownloadSecureView.vue";
import FileFormatRegistryView from "@/views/FileFormatRegistry/FileFormatRegistryView.vue";
import FormatCategoriesView from "@/views/FileFormatRegistry/sub/FormatCategoriesView.vue";
import LoginCallback from "@/views/Login/LoginCallback.vue";
import LoginView from "@/views/Login/LoginView.vue";
import PreservationPolicyView from "@/views/PreservationPolicy/PreservationPolicyView.vue";
import AddNewPolicyView from "@/views/PreservationPolicy/sub/AddNewPolicyView.vue";
import ProgessView from "@/views/Progress.vue";
import InfoPackagesView from "@/views/Report2/InfoPackagesView.vue";
import FileFormatView from "@/views/Report3/FileFormatView.vue";
import RequesterView from "@/views/RequesterReviewer/RequesterView.vue";
import ReviewerView from "@/views/RequesterReviewer/ReviewerView.vue";
import SearchView from "@/views/Search/SearchView.vue";
import AipDipView from "@/views/Search/sub/AipDipView.vue";
import FileEventListView from "@/views/Search/sub/FileEventListView.vue";
import ErrorPage from "@/views/errorPage/ErrorPage.vue";
import DownloadSystemConfigure from "@/views/AgencyList/DownloadSystemConfigure.vue";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    { path: "/", redirect: "/search" },
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: {
        hasError: true,
        requiresUnauth: true,
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
    },
    {
      path: "/login-callback",
      name: "login-callback",
      component: LoginCallback,
      meta: {
        hasError: true,
        requiresUnauth: true,
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
    },
    {
      path: "/search",
      name: "search",
      component: SearchView,
      meta: {
        //requiresAuth:true,
        hasError: true,
        breadcrumb: [{ name: "Search" }],
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
    },
    {
      path: "/search/:selectedSearchId",
      name: "aipdipdetails",
      component: AipDipView,
      meta: {
        //requiresAuth:true,
        hasError: true,
        breadcrumb: [{ name: "Search" }, { name: "AIP/DIP Details" }],
        hasPermission: [0, 2, 3, 5],
      },
      props: { default: true },
    },
    {
      path: "/search/:selectedSearchId/fileevent/:selectedFileId",
      name: "fileeventlist",
      component: FileEventListView,
      meta: {
        //requiresAuth:true,
        hasError: true,
        breadcrumb: [
          { name: "Search" },
          { name: "AIP/DIP Details" },
          { name: "File Event List" },
        ],
        hasPermission: [0, 2, 3, 5],
      },
      props: { default: true },
    },
    {
      path: "/downloadpackagessecure",
      name: "downloadpackagessecure",
      component: DownloadSecureView,
      meta: {
        hasError: true,
        breadcrumb: [
          { name: "Manage Packages" },
          { name: "Download Packages" },
        ],
        hasPermission: [0, 2, 3, 5],
      },
    },
    {
      path: "/requester",
      name: "requester",
      component: RequesterView,
      meta: {
        hasError: true,
        breadcrumb: [{ name: "Manage Packages" }, { name: "Requester View" }],
        hasPermission: [0, 2, 3, 5],
      },
    },
    {
      path: "/reviewer",
      name: "reviewer",
      component: ReviewerView,
      meta: {
        hasError: true,
        breadcrumb: [{ name: "Manage Packages" }, { name: "Reviewer View" }],
        hasPermission: [0, 3, 5],
      },
    },
    // {
    //   path: "/chartsdashboard",
    //   name: "chartsdashboard",
    //   component: ProgessView,
    //   meta: {
    //     //requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [{ name: "Manage Reports" }, { name: "Charts Dashboard" }],
    //     hasPermission: [0, 2, 3],
    //   },
    // },
    {
      path: "/infopackages",
      name: "infopackages",
      component: InfoPackagesView,
      meta: {
        //requiresAuth:true,
        hasError: true,
        breadcrumb: [
          { name: "Manage Reports" },
          { name: "Report: Information Packages Ingested" },
        ],
        hasPermission: [0, 2, 3, 5],
      },
    },
    {
      path: "/fileformat",
      name: "fileformat",
      component: FileFormatView,
      meta: {
        requiresAuth: true,
        hasError: true,
        breadcrumb: [
          { name: "Manage Reports" },
          { name: "Report: File Formats" },
        ],
        hasPermission: [0, 2, 3, 5],
      },
    },
    // {
    //   path: "/auditlog",
    //   name: "auditlog",
    //   component: AuditLogView,
    //   meta: {
    //     hasPermission: [0, 1, 2, 3],
    //     // requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [{ name: "Administration" }, { name: "Audit Log" }],
    //   },
    // },
    // {
    //   path: "/fileformatregistry",
    //   name: "fileformatregistry",
    //   component: FileFormatRegistryView,
    //   meta: {
    //     //requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [
    //       { name: "Administration" },
    //       { name: "File Format Registry View" },
    //     ],
    //     hasPermission: [0, 1],
    //   },
    // },

    // {
    //   path: "/fileformatregistry/formatcategories",
    //   name: "formatcategories",
    //   component: FormatCategoriesView,
    //   meta: {
    //     //requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [
    //       { name: "Administration" },
    //       { name: "File Format Registry View" },
    //       { name: "View Format Categories" },
    //     ],
    //     hasPermission: [0, 1],
    //   },
    // },
    // {
    //   path: "/preservation",
    //   name: "preservation",
    //   component: PreservationPolicyView,
    //   meta: {
    //     //requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [
    //       { name: "Administration" },
    //       { name: "Preservation Policy Management" },
    //     ],
    //     hasPermission: [0, 1],
    //   },
    // },
    // {
    //   path: "/preservation/addNewPolicy",
    //   name: "addnewpolicy",
    //   component: AddNewPolicyView,
    //   meta: {
    //     //requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [
    //       { name: "Administration" },
    //       { name: "Preservation Policy Management" },
    //       { name: "Add New Policy" },
    //     ],
    //     hasPermission: [0, 1],
    //   },
    // },
    // {
    //   path: "/preservation/:selectedId",
    //   name: "editpolicy",
    //   component: AddNewPolicyView,
    //   meta: {
    //     //requiresAuth:true,
    //     hasError: true,
    //     breadcrumb: [
    //       { name: "Administration" },
    //       { name: "Preservation Policy Management" },
    //       { name: "Edit Policy" },
    //     ],
    //     hasPermission: [0, 1],
    //   },
    // },
    {
      path: "/agencylist",
      name: "agencylist",
      component: AgencyListView,
      meta: {
        //requiresAuth:true,
        hasError: true,
        breadcrumb: [{ name: "Administration" }, { name: "Agency List" }],
        hasPermission: [0, 1, 4, 5],
      },
    },
    {
      path: "/downloadsystemconfiguration",
      name: "downloadsystemconfiguration",
      component: DownloadSystemConfigure,
      meta: {
        //requiresAuth:true,
        hasError: true,
        breadcrumb: [{ name: "Administration" }, { name: "Download System Configuration" }],
        hasPermission: [0, 1, 4, 5],
      },
    },
    {
      path: "/error",
      name: "error",
      component: ErrorPage,
      meta: {
        //requiresAuth:true,
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
      beforeEnter: (_, from) => {
        if (from.meta.hasError || GlobalData.getInstance().canAccessError) {
          return true;
        } else {
          return { name: "search" };
        }
      },
    },
    {
      path: "/:notFound(.*)",
      name: "notfound",
      component: ErrorPage,
      meta: {
        //requiresAuth:true,
        breadcrumb: [],
        hasPermission: [0, 1, 2, 3, 4, 5],
      },
    },
  ],
  strict: false,
});

router.beforeEach((to, _, next) => {
  const authenticationStore = useAuthenticationStore();
  const publicRoutes: Array<string | undefined> = [
    "login",
    "login-callback",
    "error",
  ];

  if (GlobalData.getInstance().hasErrorPage == true) {
    GlobalData.getInstance().hasErrorPage = false;
    next({ name: "error" });
    return;
  }

  const permissionArray: Array<number> = to.meta.hasPermission as Array<number>;
  if (
    !authenticationStore.isUserValid &&
    !publicRoutes.includes(to.name?.toString())
  ) {
    next({ name: "login" });
  } else if (authenticationStore.isUserValid && to.meta.requiresUnauth) {
    next({ name: "search" });
  } else if (!permissionArray.includes(authenticationStore.userRole)) {
    authenticationStore.decodeJwt();
    if(!permissionArray.includes(authenticationStore.userRole)) {
      GlobalData.getInstance().errorMessage.setErrorStatus(403);
      GlobalData.getInstance().hasErrorPage = false;
      GlobalData.getInstance().canAccessError = true;
      next({ name: "error" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
